import styled from 'react-emotion';

export const Seating = styled.div`
	display: block;
	height: 200px;
	margin: 1rem auto 2rem;
	position: relative;
	width: 450px;

	@media (max-width: 500px) {
		height: 160px;
		width: 100%;
	}

	@media (max-width: 375px) {
		height: 130px;
	}
`;

export const Seat = styled.span`
	border: 1px solid #fff;
	display: inline-block;
	height: 1.5rem;
	margin-right: 0.25rem;
	vertical-align: top;
	width: 1.5rem;
`;

export const Seats = styled.div`
	position: absolute;
	transform: rotate(-90deg) scaleX(-1);
	transform-origin: 0 0;
	width: 190px;

	@media (max-width: 500px) {
		width: 160px;
	}

	@media (max-width: 374px) {
		width: 130px;
	}

	span {
		float: left;
		margin: 2px;

		@media (max-width: 500px) {
			height: 1rem;
			width: 1rem;
		}

		@media (max-width: 374px) {
			height: 0.75rem;
			width: 0.75rem;
		}

		&:nth-child(7),
		&:nth-child(13),
		&:nth-child(19),
		&:nth-child(24),
		&:nth-child(29),
		&:nth-child(34),
		&:nth-child(39),
		&:nth-child(44),
		&:nth-child(49),
		&:nth-child(54),
		&:nth-child(59),
		&:nth-child(64),
		&:nth-child(70),
		&:nth-child(76) {
			clear: left;
		}
	}
`;

export const Groups = styled.div`
	display: flex;
	flex-wrap: wrap;
`;

export const Party = styled.div`
	flex: 0 0 33%;
	font-size: 0.875rem;
	line-height: 2;

	@media (max-width: 500px) {
		flex-basis: 50%;
	}

	@media (max-width: 374px) {
		flex-basis: 100%;
	}
`;

export const Senate = styled.div`
	margin-bottom: 1.5rem;
`;
